module.exports = __webpack_public_path__ + "img/brush-angle.09bc86a4.svg";